import { defineMessages } from 'react-intl';

/**
 * TODO: need to import deps here and use the remToPixesRatio from the deps file rather than importing it directly here. Can not do that right now because
 * There is a circular dependency created by the FilterTypeNav.jsx. FiltertypeNav uses this file, which in turn will import the deps which makes a reference to the FiltertypeNav.
 * Once all the domains are reconfigured and the FilterTypeNav, accesses these constants via getInDomain, this import could be moved to deps.
 */

export const SearchConstants = Object.freeze({
  STYLE_NAV: 'nav',
  ADD: 'add',
  SHUFFLE: 'Shuffle',
} as const);

export const messages = defineMessages({
  clear: {
    id: 'search.clear',
    defaultMessage: 'clear',
  },
  placeholderDefault: {
    id: 'search.placeholderDefault',
    defaultMessage: 'Search',
  },
  focusedPlaceholderDefault: {
    id: 'search.focusedPlaceholderDefault',
    defaultMessage: 'Find artists, songs, podcasts and more',
  },
  accessibleClear: {
    id: 'search.accessibleClear',
    defaultMessage: 'Clear search field',
  },
  welcomeInputPlaceHolder: {
    id: 'search.welcomeInputPlaceHolder',
    defaultMessage: 'Search for albums, artists, songs, stations',
  },
  browseGenres: {
    id: 'search.browseGenres',
    defaultMessage: 'Browse Genres',
  },
  browse: {
    id: 'search.browse',
    defaultMessage: 'Browse',
  },
  noResults: {
    id: 'search.noResults',
    defaultMessage: "We couldn't find anything matching ",
  },
  noResultsFiltered: {
    id: 'search.noResultsFiltered',
    defaultMessage: "We couldn't find any {filter} matching ",
  },
  search: {
    id: 'search.search',
    defaultMessage: 'Search',
  },
  searchFor: {
    id: 'search.searchFor',
    defaultMessage: 'Search for an artist, album, song, station or playlist',
  },
  searchKeyboardControls: {
    id: 'search.searchKeyboardControls',
    defaultMessage:
      'Search results available.  Keyboard users: use up and down arrow or tab keys to navigate search results and enter to select. Press escape to clear and return to the search input field.',
  },
  searchKeyboardControlsNoResults: {
    id: 'search.searchKeyboardControlsNoResults',
    defaultMessage:
      'No search results available.  Keyboard users: Press escape to clear and return to the search input field.',
  },
  wantHelp: {
    id: 'search.wantHelp',
    defaultMessage: 'Want help finding something new?',
  },
  babySearchInputPlaceholder: {
    id: 'search.babySearchInputPlaceholder',
    defaultMessage: 'Find a song to add',
  },
  babySearchInputPlaceholderKeyboard: {
    id: 'search.babySearchInputPlaceholderKeyboard',
    defaultMessage: 'Find a song to add or hit Enter for recommended songs',
  },
  artist: {
    id: 'search.artist',
    defaultMessage: 'Artist',
  },
  station: {
    id: 'search.station',
    defaultMessage: 'Station',
  },
  playlist: {
    id: 'search.playlist',
    defaultMessage: 'Playlist',
  },
  numSongs: {
    id: 'search.numSongs',
    defaultMessage: `{trackCount, plural,
      one {1 Song}
      other {# Songs}
    }`,
  },
  songLength: {
    id: 'search.songLength',
    defaultMessage: 'Song - {duration}',
  },
  albumLength: {
    id: 'search.albumLength',
    defaultMessage: `Album - {trackCount, plural,
      one {1 Song}
      other {# Songs}
    }`,
  },
  playlistLength: {
    id: 'search.playlistLength',
    defaultMessage: `Playlist - {trackCount, plural,
      one {1 Song}
      other {# Songs}
    }`,
  },
  stationName: {
    id: 'search.stationName',
    defaultMessage: '{name} Radio',
  },
  podcastEpisodes: {
    id: 'search.podcastEpisodes',
    defaultMessage: `Podcast - {episodeCount, plural,
      one {1 Episode}
      other {# Episodes}
    }`,
  },
  episodeReleaseDate: {
    id: 'search.episodeReleaseDate',
    defaultMessage: 'Episode - {releaseDate}',
  },
} as const);

export const coldStartWelcomeMessages = defineMessages({
  coldStartHeader: {
    id: 'search.coldStartHeader',
    defaultMessage: "Welcome to Pandora Premium. Let's get started!",
  },
  searchAndPlayTitle: {
    id: 'search.searchAndPlayTitle',
    defaultMessage: 'Search and play',
  },
  searchAndPlayTitleText: {
    id: 'search.searchAndPlayText',
    defaultMessage: 'all your favorite songs',
  },
  personalPlaylistTitle: {
    id: 'search.personalPlaylistTitle',
    defaultMessage: 'Create playlists',
  },
  personalPlaylistText: {
    id: 'search.personalPlaylistText',
    defaultMessage: '- on your own or powered by Pandora',
  },
  playTitle: {
    id: 'search.playTitle',
    defaultMessage: 'Listen',
  },
  playText: {
    id: 'search.playText',
    defaultMessage: 'to personalized stations',
  },
} as const);

export const SearchActions = Object.freeze({
  CLOSE_SEARCH: 'CLOSE_SEARCH',
  FILTER_CHANGED: 'FILTER_CHANGED',
  FULL_SEARCH: 'FULL_SEARCH',
  LEAVE_SEARCH: 'LEAVE_SEARCH',
  RESET_RESULTS: 'RESET_RESULTS',
  SEARCH_AUTOCOMPLETE: 'SEARCH_AUTOCOMPLETE',
  SEARCH_CLEAR: 'SEARCH_CLEAR',
  SEARCH_FOR: 'SEARCH_FOR',
  SEARCH_RESULTS_RENDERED: 'SEARCH_RESULTS_RENDERED',
  SEARCH_SCROLL: 'SEARCH_SCROLL',
  SEARCH_SELECT: 'SEARCH_SELECT',
  SEARCH_UI_UPDATE: 'SEARCH_UI_UPDATE',
  SEARCH: 'SEARCH',
  UPDATE_SEARCH_AUTOCOMPLETE: 'UPDATE_SEARCH_AUTOCOMPLETE',
} as const);

export const SearchKeys = Object.freeze({
  ADD_VARIETY_SEARCH: 'addVarietySearch',
  FETCHED_SEARCH_RESULTS: 'fetchedSearchResults',
  IS_FOCUS_EVENT: 'isFocusEvent',
  MAIN_SEARCH: 'mainSearch',
  PLAYLIST_TRACK_SEARCH: 'playlistTrackSearch',
  PREV_INDEX: 'prevIndex',
  RECEIVED_RESULTS_IN_LAST_REQUEST: 'receivedResultsInLastRequest',
  SEARCH_ACTIVE: 'searchActive',
  SEARCH_FILTER: 'searchFilter',
  SEARCH_HAS_FOCUS: 'hasFocus',
  SEARCH_RESULTS_NUMS: 'searchResultsNums',
  SEARCH_RESULTS: 'searchResults',
  SEARCH_TERM: 'searchTerm',
  SEARCH_TIMES: 'searchTime',
  SEARCH_TOKEN: 'searchToken',
} as const);

export const SearchStatsActions = Object.freeze({
  PLAY: 'play',
  NAVIGATE_BACKSTAGE: 'navigate_backstage',
  COLLECT: 'collect',
} as const);

// Search "scopes" are the tabbed categories you can search for
// A search scope may represent a combination of one or more search "types"
export const SearchScopes = Object.freeze({
  ALL: 'all',
  ARTISTS: 'artists',
  ALBUMS: 'albums',
  SONGS: 'songs',
  STATIONS: 'stations',
  PLAYLISTS: 'playlists',
  PODCASTS: 'podcasts',
  VARIETY: 'variety',
} as const);

export const Explicitness = Object.freeze({
  EXPLICIT: 'EXPLICIT',
  CLEAN: 'CLEAN',
} as const);

export const AnnotationRecipeTypes = Object.freeze({
  CLASS_OF_2019: 'CLASS_OF_2019',
} as const);

export default SearchConstants;
